import type { ListboxDesignTokens } from '@primeuix/themes/types/listbox';

/**
 * Listbox component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/listbox/index.ts
 *
 * Component documentation:
 * https://primeng.org/listbox
 */
export const listboxComponentTokens: Partial<ListboxDesignTokens> = {
  root: {
    borderColor: 'transparent',
  },
  optionGroup: {
    color: '{text.color}',
  },
};
